module.exports = __webpack_public_path__ + "img/header-engagementRingsVintage@2x.bb0d747.webp";